import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoDataCardIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 168,
	height: 121,
	viewBox: "0 0 168 121",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M73.1382 16.1623C53.7027 34.467 48.4613 48.2684 32.8132 56.5333C22.8632 61.7886 11.4076 65.6469 5.52996 75.2424C-15.8786 110.193 29.7558 138.941 59.1378 104.66C84.0562 75.5876 122.265 143 158.637 88.1602C191.137 39.1608 124.637 -32.3407 73.1382 16.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 73.6406,
			cy: 110.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 24.6406,
			cy: 25.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 49,
			y: 56,
			width: 22,
			height: 32,
			rx: 1,
			fill: "url(#paint0_linear_5309_16667)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 73,
			y: 12,
			width: 22,
			height: 76,
			rx: 1,
			fill: "url(#paint1_linear_5309_16667)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 97,
			y: 36,
			width: 22,
			height: 52,
			rx: 1,
			fill: "url(#paint2_linear_5309_16667)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.3337 88C97.3337 95.3638 91.3641 101.333 84.0003 101.333C76.6365 101.333 70.667 95.3638 70.667 88C70.667 80.6362 76.6365 74.6667 84.0003 74.6667C91.3641 74.6667 97.3337 80.6362 97.3337 88Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M84 80.3333C84.5523 80.3333 85 80.7811 85 81.3333V89.3333C85 89.8856 84.5523 90.3333 84 90.3333C83.4477 90.3333 83 89.8856 83 89.3333V81.3333C83 80.7811 83.4477 80.3333 84 80.3333ZM84 92.3333C84.5523 92.3333 85 92.7811 85 93.3333V94.6667C85 95.219 84.5523 95.6667 84 95.6667C83.4477 95.6667 83 95.219 83 94.6667V93.3333C83 92.7811 83.4477 92.3333 84 92.3333Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_5309_16667",
				x1: 49.839,
				y1: 57.6271,
				x2: 76.5159,
				y2: 76.1421,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_5309_16667",
				x1: 73.839,
				y1: 15.8644,
				x2: 110.256,
				y2: 26.5066,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_5309_16667",
				x1: 97.839,
				y1: 38.6441,
				x2: 131.268,
				y2: 52.9218,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgNoDataCardIcon);
export { ForwardRef as ReactComponent };
